window.ApplicationDocumentUploadForm = function (scope, Upload, applicationId, hUser, job_brand, appDocDetails, jobApplyAPI) {
    var self = this;
    var formName = "application_document_upload_form";
    var _protected = BaseForm.call(self, formName, scope);

    self.data.files = [];
    self.user_id = hUser.getUser().id;
    self.application_id = applicationId;
    self.job_brand = job_brand;
    self.app_doc_details = appDocDetails;

    var DONE = "DONE";
    var NTHN = "NTHN";
    var ERROR = "ERROR";
    var IN_PROGRESS = "IN_PROGRESS";
    self.profile_application_document_progress = NTHN;
    self.application_document_upload_error_message = null;

    self.save = function () {
    };

    self.load = function () {
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var value = self.data.files;
        self.validator.validation['application_document_upload'] = {errors: {}};

        switch (rule.name) {
            case 'required_files':
                var dependency = self.required;
                if (dependency && !value.length) {
                    if (showError) {
                        self.validator.validation['application_document_upload']['errors']['required_files'] = true;
                    }
                    return false;
                } else {
                    self.validator.validation['application_document_upload'] = {errors: {}};
                }

                break;
        }

        return true;
    };

    self.onFileSelect = function (files) {
        if (files && files[0]) {
            self.needsUpload = false;

            var nameParts = files[0].name.split(".");
            var fileExtension = nameParts[(nameParts.length - 1)].toLowerCase();

            if (['doc', 'pdf', 'docx', 'txt', 'rtf'].indexOf(fileExtension) > -1) {
                self.data.files = files;
                self.validator.validation['application_document_upload'] = {'errors': {}};

                if (self.validator.validate()) {
                    if (self.application_id) {
                        uploadDoc();
                    } else {
                        self.needsUpload = true;
                    }
                }
            } else {
                hAlert(
                    $filter("translate")("Invalid file type"),
                    $filter("translate")("Supported types are:") + " docx, doc, pdf, txt, rtf"
                );
            }
        }
    };

    self.setRequired = function (isRequired) {
        self.required = isRequired;
    };

    self.onDeleteSelectedFile = async () => {
        self.profile_application_document_progress = IN_PROGRESS;
        let isLoggedIn = hUser.isLoggedIn();
        if (isLoggedIn) {
            HStorageManager.remove({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'placeholder_token'
            });
        }
        const placeholderToken = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
            key: 'placeholder_token'
        });
        JobApplicationAPI.deleteApplicationDocumentMedia(self.application_id, self.app_doc_details.application_media_id, placeholderToken).then(() => {
            self.profile_application_document_progress = DONE;
            self.needsUpload = true;
            self.data.files = [];
            scope.$digest();
        }).catch((reason) => {
            console.error("Error while uploading:", reason);
            onRequestError();
        });
    };

    var onRequestError = function () {
        self.profile_application_document_progress = ERROR;
        self.application_document_upload_error_message = $filter("translate")("Something went wrong with your document upload!");
    };

    const uploadDoc = async () => {
        self.profile_application_document_progress = IN_PROGRESS;
        let isLoggedIn = hUser.isLoggedIn();
        if (isLoggedIn) {
            HStorageManager.remove({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'placeholder_token'
            });
        }
        const placeholderToken = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
            key: 'placeholder_token'
        });
        jobApplyAPI.getAppMediaPresignedUrl(self.application_id, self.app_doc_details.id, self.data.files[0].name, placeholderToken).then(function (response) {
            Upload.http({
                url: response.data.data.href,
                method: 'PUT',
                headers: {
                    'Content-Type': ''
                },
                data: self.data.files[0],
            }).success(async () => {
                const payload = {
                    'path': response.data.data.href,
                    'type': "application_document",
                    'application_document_id': self.app_doc_details.id,
                    'display_name':self.data.files[0].name
                };
                let isLoggedIn = hUser.isLoggedIn();
                if (isLoggedIn) {
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'placeholder_token'
                    });
                }
                const placeholderToken = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'placeholder_token'
                });
                if (placeholderToken) {
                    payload.placeholder_token = placeholderToken;
                }
                jobApplyAPI.uploadAppMedia(self.application_id, payload).then(function (res) {
                    self.app_doc_details.application_media_id = res.data.data.id;
                    self.profile_application_document_progress = DONE;
                }).catch(function (reason) {
                    console.error("Error while uploading:", reason);
                    onRequestError();
                });
            }).progress(function (evt) {
            }).error(function (reason) {
                console.error("Error while uploading:", reason);
                onRequestError();
            });
        }).catch(function (reason) {
            console.error("Error while uploading:", reason);
            onRequestError();
        });
    };

    self.uploadDoc = uploadDoc;

};
